import { createSelector } from 'reselect';
import { getProjectViewData } from 'src/modules/project-view/selectors/getProjectViewData';

export const getProjectDetails = createSelector([
  getProjectViewData,
], (data) => data.project);
